// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___nOrhc {
    margin-bottom: var(--section-margin-bottom);
}

.styles__email___GoJZ4:hover {
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/Contacts/styles.css"],"names":[],"mappings":"AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["@import \"../../styles/variables.css\";\n\n.container {\n    margin-bottom: var(--section-margin-bottom);\n}\n\n.email:hover {\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___nOrhc`,
	"email": `styles__email___GoJZ4`
};
export default ___CSS_LOADER_EXPORT___;
